// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QioS0XxwkJ4gZsVYemz5{margin:2px 0 0 1px}.kjfXmIKdcEcbD_ded0Se{margin:2px 0 0 4px}.Gs1TL1Mayf4c3p0fWzpV{flex-direction:column;align-items:flex-start;display:flex}.GdC0n2WsWQLo2q2TPq3C{white-space:nowrap}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flagUSA": `QioS0XxwkJ4gZsVYemz5`,
	"flagUsa": `QioS0XxwkJ4gZsVYemz5`,
	"flagCanada": `kjfXmIKdcEcbD_ded0Se`,
	"tooltipLabel": `Gs1TL1Mayf4c3p0fWzpV`,
	"tooltipText": `GdC0n2WsWQLo2q2TPq3C`
};
export default ___CSS_LOADER_EXPORT___;
